// Firebase v9 modular SDK 
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCLq7QHogSwpWmo5y0KLdCFL43Ganmi1Gs",
  authDomain: "requestasong-4472b.firebaseapp.com",
  projectId: "requestasong-4472b",
  storageBucket: "requestasong-4472b.firebasestorage.app",
  messagingSenderId: "961410555472",
  appId: "1:961410555472:web:48a7d632d638b62f58fb55",
  measurementId: "G-5FW2P4NXSH"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Explicitly set the functions region to us-central1
export const functions = getFunctions(app, 'us-central1');

export { app };